export default __webpack_public_path__ + "static/media/img--LUX-terrace-2.e276c912.jpg";